
import { useMemo } from 'react';
import { PlatformIntelligence } from '@/utils/platform-intelligence';
import { RefundFormValues } from './use-refund-form';

export const usePlatformIntelligence = (
  values: RefundFormValues,
  userLocation?: { country?: string }
) => {
  const platformAnalysis = useMemo(() => {
    if (!values.merchant) return null;
    
    return PlatformIntelligence.analyze(
      values.merchant,
      values.orderNumber,
      values.issue,
      parseFloat(values.amount) || 0,
      userLocation?.country
    );
  }, [values.merchant, values.orderNumber, values.issue, values.amount, userLocation?.country]);

  return {
    platformInfo: platformAnalysis?.platformInfo,
    strategy: platformAnalysis?.strategy,
    recommendations: platformAnalysis?.recommendations,
    isAnalyzed: !!platformAnalysis
  };
};
